import { deltaKindSchema, EdlinkOrgChartDryRunResult, EdlinkOrgChartImportSummary } from '@airreading/common/data';
import { DeltaKindGroup } from './delta-kind-group';
import { NormalizedEntityItem } from '@/lib/edlink-utils';

interface ImportSummaryProps {
  summary: EdlinkOrgChartImportSummary | EdlinkOrgChartDryRunResult;
}

export function ImportSummary({ summary }: ImportSummaryProps) {
  const isDryRun = Array.isArray(summary);
  const items: NormalizedEntityItem[] = isDryRun
    ? summary.map(({ delta, kind, label, details }) => ({ type: delta, kind, label, details }))
    : summary.items;
  const failures: NormalizedEntityItem[] = isDryRun ? [] : summary.failureItems;
  const skipsCount = isDryRun ? 0 : summary.skipsCount;
  const deltaKindOrder = deltaKindSchema.options;
  const deltaByKind = Map.groupBy(items, (item) => item.kind);

  return (
    <div className="flex flex-col gap-2">
      {deltaKindOrder.map((kind) => (
        <DeltaKindGroup key={kind} kind={kind} items={deltaByKind.get(kind) ?? []} isDryRun={isDryRun} />
      ))}
      {!isDryRun && (
        <>
          <div className={`border-l-4 border-l-orange-500 pl-3 py-1 text-sm font-medium`}>
            Failed items: {failures.length}
          </div>
          <div className={`border-l-4 border-l-gray-400 pl-3 py-1 text-sm font-medium`}>
            Skipped items: {skipsCount}
          </div>
        </>
      )}
    </div>
  );
}
